import { createSlice } from '@reduxjs/toolkit';
import { jwtDecode } from "jwt-decode";

const initialState = {
  isLoggedIn: Boolean(localStorage.getItem('token')),
  token: localStorage.getItem('token') || null,
  user: {
    username: '',
    email: '',
    roles:'',
    modules:''
  },
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    login: (state, action) => {
      state.isLoggedIn = true;
      state.token = action.payload.token;  // Store the token
      localStorage.setItem('token', action.payload.token); // Save token to localStorage
      const decodedToken = jwtDecode(action.payload.token);
      state.user.username = decodedToken.name;
      state.user.email = decodedToken.email;
      state.user.roles = decodedToken.roles;
      state.user.modules = decodedToken.modules;
    },
    logout: (state) => {
      state.isLoggedIn = false;
      state.token = null;
      state.user = { username: '', email: '',roles:'',modules:'' };
      localStorage.removeItem('token'); // Remove token from localStorage
    },
  },
});

export const { login, logout } = authSlice.actions;

export default authSlice.reducer;